import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/weekly-reports`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/weekly-reports/${id}?include=organization,cafeteria,serviceCenter,establishment`, options)
    .then((response) => {
      let weeklyReport = jsona.deserialize(response.data);
      delete weeklyReport.links;
      return weeklyReport;
    });
}

function add(weeklyReport) {
  const payload = jsona.serialize({
    stuff: weeklyReport,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/weekly-reports?include=`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(weeklyReport) {
  const payload = jsona.serialize({
    stuff: weeklyReport,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(`${url}/weekly-reports/${weeklyReport.id}?include=organization,cafeteria,serviceCenter,establishment`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/weekly-reports/${id}`, options);
}

function refresh(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.get(`${url}/weekly-reports/${id}/refresh`, {}, options);
}

// Update the downloadZip function to use AJAX
function downloadZip(params) {
  const apiUrl = `${url}/weekly-reports/weekly-reports-zip`;

  return axios({
    url: apiUrl,
    method: 'GET',
    responseType: 'blob', // Important for file downloads
    params: {
      start_date: params.start_date,
      end_date: params.end_date
    }
  }).then(response => {
    // Get filename from content-disposition header or create default name
    let filename = 'weekly_reports.zip';
    const contentDisposition = response.headers['content-disposition'];
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="(.+)"/);
      if (filenameMatch && filenameMatch.length === 2) {
        filename = filenameMatch[1];
      }
    }

    // Create a blob URL and trigger download
    const blob = new Blob([response.data], { type: 'application/zip' });
    const downloadUrl = window.URL.createObjectURL(blob);

    return {
      blob,
      url: downloadUrl,
      filename
    };
  });
}

function validate(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/weekly-reports/${id}/validate?include=organization,cafeteria,serviceCenter,establishment`, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function revertToDraft(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/weekly-reports/${id}/revert-to-draft?include=organization,cafeteria,serviceCenter,establishment`, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function openItemsCheck(id) {
  return axios
    .get(`${url}/weekly-reports/${id}/open-items-check`)
    .then((response) => response.data.data);
}

/**
 * Product-level detail of what was actually invoiced internally that week.
 * Only ACCEPTED internal invoices feed it, exactly like the report aggregates.
 */
function internalInvoiceProducts(id) {
  return axios
    .get(`${url}/weekly-reports/${id}/internal-invoice-products`)
    .then((response) => response.data);
}

export default {
  list,
  get,
  add,
  update,
  destroy,
  refresh,
  downloadZip,
  validate,
  revertToDraft,
  openItemsCheck,
  internalInvoiceProducts,
};
